module.exports = __webpack_public_path__ + "img/toplogo.4c768e8d.png";